<template>
  <div class="shoplist">
    <div class="desc">
      视频中提到({{noticeList.length}})
    </div>
    <div v-show="isShowLoading" class="loading"></div>
    <div class="list">
      <ul >
        <li v-for="(item, index) of noticeList" :key="index">
          <!-- <div>{{item}}</div> -->
          <a class="" :href="item.href" :class="item.typeClass" >
            <div class="item">
              <div class="pic">
                  <div :data-imgurl="fixImgUrl(item.avatar)" alt="" class="lazy-img"></div>
              </div>
              <div class="content">
                <div class="name title">
                    <span class="shop_name">
                      {{item.title}}
                    </span>
                </div>
                <div class="comment" v-if="item.price || (item.objectType != 2 && item.objectType != 6 && item.objectType != 7 && item.objectType != 8 && item.objectType != 9 && item.objectType != 10 && item.objectType != 11  && item.objectType != 12)">
                  <span class="star" :class="item.starClass"></span>
                  <span class="price">{{item.price}}</span>
                </div>
                <div class="comment" v-if="item.objectType === 8 || item.objectType === 9 || item.objectType === 10 || item.objectType === 11">
                  <span class="price" >{{item.labelFirst}}</span>
                </div>
                <template v-if="item.objectType == 12">
                  <div class="intro col">
                    <p class="hasSec">{{item.labelFirst}}</p>
                    <p>{{item.labelSecond}}</p>
                  </div>
                </template>
                <template v-else>
                  <div class="intro" :class="item.objectType == 2 || item.objectType == 6 || item.objectType == 7 ? 'col' : ''">
                    <span :class="item.labelSecond ? 'hasSec' : ''" v-if="item.objectType != 8 && item.objectType != 9 && item.objectType != 10 && item.objectType != 11">{{item.labelFirst}}</span>
                    <span class="type">{{item.labelSecond}}</span>
                  </div>
                </template>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import lazyLoad from '../libs/lazy'
  export default {
    name: 'shopList',
    data () {
        return{

        }
    },
    props: ['osName', 'noticeList','isShowLoading', 'appName'],
    updated () {
      let scrollEl = document.querySelector('.video-header')
      let lazy = new lazyLoad(document.getElementsByClassName("lazy-img"), false, scrollEl)
      this.$nextTick(function () {
        lazy.loadImg()
      })
    },
    mounted () {
      let scrollEl = document.querySelector('.video-header')
      let lazy = new lazyLoad(document.getElementsByClassName("lazy-img"), false, scrollEl)
      
      scrollEl.addEventListener('scroll', function () {
        console.log('scroll')
        lazy.loadImg();
      }, false)
      window.onload = function (){
        lazy.loadImg();
      }
    },
    methods:{
      fixImgUrl(img) {
        return img && img.indexOf('http://') !== -1 ? img.replace('http://', 'https://') : img;
      },
      loadData () {

      },
      moreShop () {

      }

    }

  }
</script>



// WEBPACK FOOTER //
// noticelist.vue?dba7e7d2